import { motion } from "framer-motion";
import { CONTENT } from "../data/content";

export const Statement = () => (
    <section
        id="statement"
        className="border-t border-white/10 px-6 py-32 md:px-12 md:py-48"
        data-testid="statement-section"
    >
        <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="mb-12 font-body text-xs uppercase tracking-[0.4em] text-zinc-500"
        >
            Artist Statement
        </motion.p>
        <motion.blockquote
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-120px" }}
            transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
            className="max-w-4xl font-editorial text-2xl font-medium italic leading-relaxed text-white md:text-4xl md:leading-snug"
            data-testid="statement-text"
        >
            <span className="mr-3 font-display not-italic text-[#E50914]">&mdash;</span>
            {CONTENT.statement}
        </motion.blockquote>
        <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1, delay: 0.4 }}
            className="mt-12 font-display text-xl tracking-[0.25em] text-zinc-400"
        >
            {CONTENT.name}
        </motion.p>
    </section>
);
